const HOME_DELIVERY_OPTIONS = [
  'POST',
  'COURIER',
  'POST_EXPRESS',
  'COURIER_EXPRESS',
];

export default {
  somePrints(prints) {
    return prints && !!prints.quantity;
  },

  somePrismItems(prismItems) {
    return prismItems && !!prismItems.length;
  },

  totalQuantity({ prints, prismItems }) {
    const printsQuantity = this.alivePrintSizes(prints).reduce((memo, size) => {
      return memo + size.quantity;
    }, 0);

    return this.alivePrismItems(prismItems).reduce(
      (memo, prismItem) => memo + prismItem.quantity,
      printsQuantity || 0
    );
  },

  lineItemCount({ prints, prismItems }) {
    return (
      (this.alivePrints(prints) ? 1 : 0) +
      this.alivePrismItems(prismItems).length
    );
  },

  totalVouchers({ vouchers }) {
    return (vouchers || []).reduce((memo, voucher) => {
      return memo + voucher.discount_amount;
    }, 0);
  },

  shippingCost({ prints, prismItems }) {
    let total = 0;

    const deliveryOption =
      this.somePrints(prints) &&
      (prints.delivery_options || []).find(d => d.key == prints.delivery);
    if (deliveryOption && deliveryOption.cost) {
      total += deliveryOption.cost;
    }

    for (let item of this.alivePrismItems(prismItems)) {
      if (item.delivery && item.delivery.cost) {
        total += item.delivery.cost;
      }
    }

    return total;
  },

  subtotalPrice({ prints, prismItems }) {
    const printsPrice = this.alivePrintSizes(prints).reduce((memo, size) => {
      return memo + size.total_price;
    }, 0);

    return this.alivePrismItems(prismItems).reduce(
      (memo, prismItem) => memo + prismItem.cost,
      printsPrice || 0
    );
  },

  totalPrice({ prints, prismItems, vouchers }) {
    return Math.max(
      0,
      this.subtotalPrice({ prints, prismItems }) -
        this.totalVouchers({ vouchers })
    );
  },

  homeDeliveryItemsPrice({ prints, prismItems }) {
    const itemsWithDelivery = [
      this.alivePrintSizesWithDelivery(prints),
      ...this.alivePrismItems(prismItems),
    ].filter(Boolean);

    return itemsWithDelivery.reduce((sum, item) => {
      const deliveryOption = (item.delivery_options || []).find(
        (option) => option.key === item.delivery,
      );

      if (
        deliveryOption &&
        HOME_DELIVERY_OPTIONS.includes(deliveryOption.type)
      ) {
        return sum + (item.total_price || item.cost);
      }
      return sum;
    }, 0);
  },

  alivePrintSizesWithDelivery(prints) {
    const aliveSizes = this.alivePrintSizes(prints);

    if (!aliveSizes.length) return null;

    const totalPrice = aliveSizes.reduce((memo, size) => memo + size.total_price, 0);

    return {
      total_price: totalPrice,
      delivery: prints.delivery,
      delivery_options: prints.delivery_options,
    };
  },

  alivePrints(prints) {
    return this.somePrints(prints) && !!this.alivePrintSizes(prints).length
      ? prints
      : null;
  },

  alivePrintSizes(prints) {
    if (!this.somePrints(prints)) {
      return [];
    }

    return prints.sizes.filter(
      size =>
        !size.deleted &&
        !(prints.deletedFinishes || []).includes(size.print_finish_key)
    );
  },

  alivePrismItems(prismItems) {
    return (prismItems || []).filter(prismItem => !prismItem.deleted);
  },
};
